import { Dtos, type SuretyAccountId, type SuretyBondId, type SuretyQuoteId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useRequest } from "../../utils/request";
import { followedEntitiesQueryKey } from "./followers.keys";

type FollowedEntities = Dtos.Follower.Followed.Get.Response;

const EMPTY_ACCOUNT_IDS: SuretyAccountId[] = [];
const EMPTY_QUOTE_IDS: SuretyQuoteId[] = [];
const EMPTY_BOND_IDS: SuretyBondId[] = [];

export type FollowedEntityIds = {
	accountIds: Set<SuretyAccountId>;
	quoteIds: Set<SuretyQuoteId>;
	bondIds: Set<SuretyBondId>;
};

export const useFetchFollowedEntities = (options?: { enabled?: boolean }) => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: followedEntitiesQueryKey(),
		queryFn: async () => await get<FollowedEntities>("/v2/followers/me"),
		enabled: options?.enabled ?? true,
	});

	const followed = useMemo<FollowedEntityIds>(
		() => ({
			accountIds: new Set(data?.accountIds ?? EMPTY_ACCOUNT_IDS),
			quoteIds: new Set(data?.quoteIds ?? EMPTY_QUOTE_IDS),
			bondIds: new Set(data?.bondIds ?? EMPTY_BOND_IDS),
		}),
		[data],
	);

	return {
		followed,
		followedEntitiesError: error,
		followedEntitiesIsLoading: isLoading,
	};
};
